/* eslint-disable prefer-const */
/* eslint-disable radix */
/* eslint-disable no-useless-escape */
// Simple validation mixin. New cases can be added as new if statements.
// Args:
//      e: event being triggered OR name of an input element
//         (name of element must either be a key in the data of the vue component
//         OR be a key in a 'stored' object in the vue component's data)
//      check: array of checks to make on the input.
//             Ex. ['req', 'domain'] is an input that is required and must be a valid domain
//
// Checks:
//      req: input cannot be empty, is required
//      domain: input must be a valid domain
//      number: input can only contain numbers
//      password: passwords must contain at least one lowercase and capital letter, a number, and be at least 12 chars long
//      email: input must be a valid email
//      code: input must be a valid verification code (6 digits)
//      phone: input must be valid phone number

import { parsePhoneNumberFromString as parsePhone } from 'libphonenumber-js/max';

export default {
    data() {
        return {
            stored: {},
            errors: {},
        };
    },
    methods: {
        validate(e, check) {
            let value = e.target ? e.target.name : e;
            let pointer = this.stored[value] ? this.stored[value] : this[value];
            let storedValue = JSON.parse(JSON.stringify(pointer));
            let add = {};
            let domainRegex = /(([a-zA-Z0-9_][a-zA-Z0-9\-_]{0,61})?[a-zA-Z0-9_]\.)+(([a-zA-Z0-9][a-zA-Z0-9\-]{0,61})?[a-zA-Z0-9])/;
            let emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
            let phoneRegex = /^\+?[0-9]{6,24}$/;
            if (check.includes('req') && !storedValue) {
                add[value] = 'Field cannot be empty';
                if (value === 'terms') {
                    add[value] = 'You must agree to the terms and conditions';
                }
                this.errors = { ...this.errors, ...add };
                return false;
            }
            if (check.includes('domain') && !storedValue.match(domainRegex)) {
                add[value] = 'Must be a valid domain';
                this.errors = { ...this.errors, ...add };
                return false;
            }
            if (storedValue && check.includes('number') && !parseInt(storedValue.replace(/[,|.]/g, ''))) {
                add[value] = 'Must be a number';
                this.errors = { ...this.errors, ...add };
                return false;
            }
            if (storedValue !== null && check.includes('password')) {
                // always returns an Object with the keys shown in the isValidPassword function
                const arr = this.isValidPassword(storedValue);
                // The third value of the check array is the score/strength of the password
                if (check.length > 2) {
                    if (check[2] < 3) {
                        add[value] = 'Password is not strong enough';
                        this.errors = { ...this.errors, ...add };
                        return false;
                    }
                    add[value] = '';
                    this.errors = { ...this.errors, ...add };
                    return true;
                }
                add[value] = arr;

                this.errors = { ...this.errors, ...add };
                return arr.total;
            }
            if (storedValue && check.includes('email') && !storedValue.match(emailRegex)) {
                add[value] = 'Must be a valid email';
                this.errors = { ...this.errors, ...add };
                return false;
            }
            if (storedValue && check.includes('code') && (!parseInt(storedValue.replace(/[,|.]/g, '')) || storedValue.length !== 6)) {
                add[value] = 'Verification code must contain 6 digits';
                this.errors = { ...this.errors, ...add };
                return false;
            }
            if (storedValue && check.includes('phone') && (!storedValue.match(phoneRegex) || !this.isValidPhone(storedValue))) {
                add[value] = 'Please enter a valid phone number with the country code.';
                this.errors = { ...this.errors, ...add };
                return false;
            }
            add[value] = '';
            this.errors = { ...this.errors, ...add };
            return true;
        },
        isValidPassword(password) {
            let checks = {
                lowercase: (pwd) => pwd.match(/(.*[a-z].*)/),
                uppercase: (pwd) => pwd.match(/(.*[A-Z].*)/),
                digit: (pwd) => pwd.match(/(.*\d.*)/),
                special: (pwd) => pwd.match(/(.*[!#$%&()*+,-./?@[\]^_{|}~].*)/),
                invalid: (pwd) => !pwd.match(/(.*["':;<=>`~].*)/),
                length: (pwd) => pwd.length >= 8,
            };
            let errors = {};
            let keys = Object.keys(checks);
            let valid = true;
            keys.forEach((key) => {
                let curr = !!checks[key](password);
                valid = curr && valid;
                errors[key] = curr;
            });
            errors.total = valid;
            return errors;
        },
        isValidPhone(phone) {
            let parsed = parsePhone(phone);
            return parsed && parsed.isValid();
        },
    },
};
